import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { RouteError } from "@/shared/components/RouteError";
import { hasPermission } from "@/shared/utils/permissions";

// Layer 1 of the triple-derived gate (BEL-467) — see `stations.tsx`.
export const Route = createFileRoute("/app/admin/devices")({
  beforeLoad: ({ context }) => {
    if (!hasPermission(context.auth.user, "admin.devices.read")) {
      throw redirect({ to: "/app" });
    }
  },
  errorComponent: ({ error }) => <RouteError error={error} />,
  component: () => <Outlet />,
});
